module.exports = __webpack_public_path__ + "static/media/post-complete-mask.26ea4283.png";